export default {
    name: "SetupValidationHelper",
    data: function () {
        return {
            nextRouteName: null,
            errors: {},
        }
    },
    methods: {
        resetErrors: function () {
            this.errors = Object.fromEntries(Object.entries(this.errors).map(v => [v[0], []]));
        },
        validate: function () {
        }
    },
    beforeRouteLeave(to, from, next) {
        if (to.name !== this.nextRouteName) {
            next();
            return;
        }

        this.validate();

        let length = Object.values(this.errors).filter(v => !!v.length).length;
        if (!length) {
            next()
        } else {
            this.$nextTick(function () {
                let errors = window.document
                    .querySelector('.invalid-feedback, .invalid-tooltip');
                if(!errors){
                    next();
                    return
                }
                let boundingClientRect = errors
                    .closest('.choice-wrap')
                    .getBoundingClientRect();
                window.scrollTo({
                    top: (boundingClientRect.top + window.document.documentElement.scrollTop) - 120,
                    left: boundingClientRect.left,
                    behavior: 'smooth'
                })
            });
            next(false)
        }
    }
}
